import {PrintData} from "./print-data";
import domtoimage from 'dom-to-image-more';


/**
 * (클라이언트 png 방식) 송장 출력데이터
 */
export default new PrintData({
    id: '',
    desc: 'PNG(클라이언트) 방식 송장출력',

    makeQzDataPromise: (house_id, blno, printer, overlay) => {
        //let url = '/printer-guide/qz-sample.pdf';
        //url = '/houses/1038393/bl?__accept=pdf&outline=no'; // 일본항공
        //url = '/houses/1038714/bl?__accept=pdf&outline=no'; // 미국


        // pdf 아웃라인 결정
        let outline = 'no';
        if (printer && printer.label) {
            outline = printer.label.emptyLine ? 'yes' : 'no';
        }

        let url = `/houses/${house_id}/bl?__accept=client-png&outline=${outline}&`;
        if (blno) {
            url += `blno=${blno}`;
        }

        // 화면 block
        if (overlay) {
            overlay.overlayOn();
        }

        // 아이프레임에 해당 url 추가
        const iframe = document.createElement('iframe');
        iframe.src = url; // iframe에 표시할 URL
        iframe.width = '0'; // 너비 설정
        iframe.height = '0'; // 높이 설정
        iframe.style.border = 'none'; // 테두리 제거
        //iframe.style.display = 'none'; // 테두리 제거
        document.body.appendChild(iframe);



        return new Promise((resolve, reject) => {
            // 온로드 이벤트
            iframe.onload = () => {
                const iframeDoc = iframe.contentWindow.document;
                const dom = iframeDoc.getElementsByClassName('label')[0];
                const rect = dom.getBoundingClientRect();
                domtoimage
                    .toPng(dom, {
                        width: rect.width, 
                        height: rect.height, 
                        scale: 3, // 이미지 선명하게 출력되도록 3배처리
                    })
                    .then(function (dataUrl) {
                        //var img = new Image();
                        //img.src = dataUrl;
                        //document.body.appendChild(img);
                        //console.log(dataUrl);
                        //return;
                        let data = [{
                            type: 'pixel',
                            format: 'image',
                            flavor: 'base64',
                            data: dataUrl,
                            customConfigOptions: {
                                rotation: 270, // 회전시켜줘야함
                            }
                        }];
                        resolve(data);

                        console.log('PNG 송장 데이터 생성완료!');

                        // iframe 제거
                        document.body.removeChild(iframe);

                        // 화면 block 종료
                        if (overlay) {
                            overlay.overlayOff();
                        }

                    });

            }

        });





    },
})